import { httpPc } from "@/utils/httpPc"


type QuickBiReportAlertConfigUpdateType = {
  report:string  // report slug
  config:Record<string,any>
}


export const quickBiReportAlertConfigUpdate = (data:QuickBiReportAlertConfigUpdateType)=>{
  let newData = {
    config: JSON.stringify(data.config),
    report: data.report,
  }
  return httpPc.post<AxiosHttpPromise<any>>(`/Manager/Report/quickBiReportAlertConfig`,newData)
}